import { cloneDeep } from "lodash";
import { Account } from "./";

const DEFAULT_ATTRIBUTES = {
  account: null,
  active: false,
  admin: false,
  avatar_url: null,
  confirmation_sent_at: null,
  email: "",
  invite_code: null,
  last_name: "",
  mercurio: null,
  name: "",
  onboarded: false,
  password: null,
  permissions_scope: "",
  role: null,
  type: null,
};

export class User {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      if (key === "account") {
        this.account = new Account(attrs[key]);
      } else {
        this[key] = attrs[key];
      }
    });
  }

  get fullName() {
    return `${this.name || ""} ${this.last_name || ""}`;
  }

  get isEmailConfirmed() {
    return !!this.confirmed_at;
  }

  //? methods related to user account
  get hasChatSupport() {
    return this.account.hasChatSupport;
  }

  get isAdmin() {
    return this.account.isShipnow;
  }

  //? Si agregamos otra cuenta ademas de shipnow como multi cuenta tenemos que revisar
  //? los casos de uso del loggedInUser.isAdmin porque puede ser que lo correcto sea usar
  //? isMultiAccount en vez de isAdmin.
  get isMultiAccount() {
    return this.isAdmin;
  }

  get isWarehouseOwner() {
    if (!this.account) {
      return false;
    }

    return this.account.isWarehouseOwner;
  }

  abilities = {
    createReturn: () => {
      return this.isAdmin || this.account.active;
    },
    createExchange: () => {
      return this.isAdmin || this.account.active;
    },
  };

  canBe(action) {
    if (this.abilities.hasOwnProperty(action)) {
      return this.abilities[action](this);
    }
  }

  get canEditDispatchDate() {
    return this.account.isWarehouseOwner || this.isAdmin;
  }
}
